import styled from 'styled-components'


export const Breadcrumbs = styled.ul`
   list-style: none;
   padding-left: 100px;
   margin: 0em auto 2em auto;

  & > li:after {
    color: #999999;
    content: "/";
    padding: 0 8px;
  }
  @media (max-width: ${props => props.theme.breakpoints.md}){
      display:none;    
   }   
`

export const Crumb = styled.li`
  display: inline-block;
  color:#000000;
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  line-height: 21.79px;
  &:last-of-type:after {
    content: "";
    padding: 0;
  }

  a {
    color: #999999;
    font-weight: 400;
    text-decoration: none;
    cursor:pointer;
    &:hover,
    &:active {
      text-decoration: underline;
    }
  }
`